import React from 'react';
import styled from 'styled-components';

interface SectionProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
  backgroundColor?: string;
  fullWidth?: boolean;
}

const SectionWrapper = styled.section<{ $backgroundColor?: string }>`
  background-color: ${({ $backgroundColor, theme }) => 
    $backgroundColor || theme.colors.white};
  width: 100%;
`;

const SectionContainer = styled.div<{ $fullWidth?: boolean }>`
  width: 100%;
  max-width: ${({ $fullWidth }) => $fullWidth ? '100%' : '1200px'};
  margin: 0 auto;
  padding: ${({ $fullWidth, theme }) => 
    $fullWidth ? '0' : `0 ${theme.space.md}`};
`;

const Section: React.FC<SectionProps> = ({
  id,
  className,
  children,
  backgroundColor,
  fullWidth = false,
}) => {
  return (
    <SectionWrapper id={id} className={className} $backgroundColor={backgroundColor}>
      <SectionContainer $fullWidth={fullWidth}>
        {children}
      </SectionContainer>
    </SectionWrapper>
  );
};

export default Section;
